import Image from '@tiptap/extension-image';

const CustomImage = Image.extend({
  addKeyboardShortcuts() {
    return {
      Enter: ({ editor }) => {
        const {
          state: {
            selection: { $from },
          },
        } = editor;

        if ($from.node().type.name !== 'xingImage') {
          return false;
        }

        const startPosition = $from.start() - 1;

        return editor
          .chain()
          .focus()
          .insertContentAt(startPosition, { type: 'paragraph' })
          .run();
      },
    };
  },
});

export default CustomImage;
